import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";

export default function Founder() {
  return (
    <BackgroundWrapper>
      <div className="pt-8 pb-20 px-4 min-h-screen flex justify-center">
        <div className="max-w-5xl bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-4 md:p-8">
          <Link
            to="/who-we-are"
            className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold text-sm sm:text-base"
          >
            ← Back to Who We Are
          </Link>

          <h1 className="text-3xl sm:text-5xl font-bold text-slate-800 mb-8 text-center">
            The Founder
          </h1>

          <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
            <strong>H.E. Ghassan Hasbani</strong> is Chairman of the Board of Directors at CAT International,
            Member of Parliament in Lebanon, and former Deputy Prime Minister and Minister of Public Health.
          </p>

          <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
            He previously served as CEO of STC International and as Partner at Booz Allen Hamilton (now part of PwC’s Strategy&). 
            He held senior positions at Nortel and Cable & Wireless in the UK, serving global markets. 
            He has chaired and participated in numerous non-executive boards and mentored senior leaders on governance and transformation.
          </p>

          <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
            Ghassan is a former member of the World Economic Forum Futures Council on the Middle East and a Fellow of the Aspen Institute.
            He is also the author of several books on communication, economics, and socio-politics.
          </p>

          <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
            He holds a <strong>First-Class Honours Degree in Engineering</strong> and an <strong>MBA</strong>, is a <strong>Chartered Engineer (C.Eng.)</strong>,
            <strong> MIET</strong>, and a <strong>Certified Executive & Organizational Development Coach</strong> by the International Coaching Federation (ICF), U.S.
          </p>

          <div className="text-center mt-10">
            <Link
              to="/contact"
              className="bg-gradient-to-r from-blue-600 to-indigo-600 text-sm sm:text-base text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:shadow-xl transition-all"
            >
              Contact Us <ChevronRight className="inline ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
